import { SavedCard } from '../WalletSavedCardsSection.types';

/**
 * Mock saved cards data for local dev and author mode
 * Mirrors the structure returned from phoenixAccountGetWalletPaymentInfo API
 */
export const walletSavedCardsSectionMock: SavedCard[] = [
  {
    id: 'card-001',
    cardNumber: '8563',
    cardholderName: 'Samantha Smith',
    cardType: 'VISA',
    expiryDate: '12/26',
    isPrimary: true,
    cardStatus: 'ACTIVE',
    cardArt: 'https://www.dev-cdn.marriott.com/images/card-visa-bonvoy.png',
  },
  {
    id: 'card-002',
    cardNumber: '9009',
    cardholderName: 'Samantha Smith',
    cardType: 'MASTERCARD',
    expiryDate: '08/27',
    isPrimary: false,
    cardStatus: 'ACTIVE',
    cardArt: 'https://www.dev-cdn.marriott.com/images/card-mastercard.png',
  },
  {
    id: 'card-003',
    cardNumber: '2691',
    cardholderName: 'Samantha Smith',
    cardType: 'AMEX',
    expiryDate: '03/25',
    isPrimary: false,
    cardStatus: 'ACTIVE',
    cardArt: 'https://www.dev-cdn.marriott.com/images/card-amex.png',
  },
];

/**
 * Empty saved cards scenario for testing empty state
 */
export const walletSavedCardsEmptyMock: SavedCard[] = [];

/**
 * Single card scenario for testing singular badge label
 */
export const walletSavedCardsSingleMock: SavedCard[] = [
  {
    id: 'card-001',
    cardNumber: '4242',
    cardholderName: 'Jane Doe',
    cardType: 'VISA',
    expiryDate: '12/26',
    isPrimary: true,
    cardStatus: 'ACTIVE',
  },
];
